// extracted by mini-css-extract-plugin
export default {"root":"TopicList_root__5Gkk1"};